export const HOTKEYS = {
  "mod+b": "bold",
  "mod+i": "italic",
  "mod+u": "underline",
};
export const TEXT_ALIGN_TYPES = ["left", "center", "right", "justify"];
